import { produce } from 'immer';

import { UpdateImportWizardStep } from '../../actions/importWizard/updateImportWizardStep';
import { ImportWizardState } from '../../typings/importWizard';

export function updateImportWizardStep(state: ImportWizardState, action: UpdateImportWizardStep): ImportWizardState {
    return produce(state, draft => {
        draft.phase = action.phase;
    });
}
